// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    PERSON_INDEX_SECTION_PAGE_LOADING() {
      return {
        isLoading: true,
        personIndexSectionPage: action.personIndexSectionPage
      };
    },
    PERSON_INDEX_SECTION_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.personIndexSectionPage
      };
    },
    PERSON_INDEX_SECTION_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.personIndexSectionPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
